import React, { useEffect, useState } from "react";
import Loader from "../components/Loader";

export default function LoaderGate({ children }) {
  const [showLoader, setShowLoader] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowLoader(false);
    }, 1800); // ⏳ tiempo del loader (1.8s)

    return () => clearTimeout(timer);
  }, []);

  return <>{showLoader ? <Loader /> : children}</>;
}
